/**
 * TrendCharts.js
 * Renders sparkline trend charts for the leaderboard.
 * Requires Chart.js to be loaded globally.
 */
export default class TrendCharts {
    constructor(selector = '.trend-chart') {
        this.charts = document.querySelectorAll(selector);
        if (!this.charts.length) return;

        this.init();
    }

    init() {
        this.charts.forEach(canvas => this.createChart(canvas));
    }

    createChart(canvas) {
        // 1. Parse all scores from the data attribute
        let scores = canvas.dataset.scores
            .split(',')
            .map(v => (v === 'null' || v === '') ? null : Number(v))
            .filter(v => v !== null);

        if (!scores.length) return;

        let labels = scores.map((_, i) => `W${i + 1}`);

        // --- WEEK 1 HORIZONTAL LINE HACK ---
        // If only one week exists, duplicate it to force a horizontal line across the canvas
        if (scores.length === 1) {
            scores = [scores[0], scores[0]];
            labels = ['W1 Start', 'W1 End'];
        }

        // 2. Trend Logic: Color based on the LAST 3 entries
        const lastWeeks = scores.slice(-3);
        let trendColor = '#888888'; // Default Gray (Steady/Flat)

        if (scores.length > 2) {
            const oldestOfLast = lastWeeks[0];
            const mostRecent = lastWeeks[lastWeeks.length - 1];

            if (mostRecent > oldestOfLast) {
                trendColor = '#28a745'; // Green (Trending Up)
            } else if (mostRecent < oldestOfLast) {
                trendColor = '#dc3545'; // Red (Trending Down)
            }
        }

        new Chart(canvas.getContext('2d'), {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    data: scores,
                    borderColor: trendColor,
                    borderWidth: 2,
                    tension: 0.3, // Slight curve for multi-week, flat for week 1
                    pointRadius: 0,
                    fill: false,
                    borderCapStyle: 'round'
                }]
            },
            options: {
                responsive: false,
                maintainAspectRatio: false,
                layout: {
                    padding: { top: 2, bottom: 2 }
                },
                scales: {
                    x: { display: false },
                    y: {
                        display: true, // Needed to render the grid lines
                        min: -0.5,     // Offset so 0 doesn't sit exactly on the line
                        max: 16.5,    // Offset so 16 doesn't sit exactly on the line
                        ticks: { display: false },
                        grid: {
                            drawBorder: false,
                            drawOnChartArea: true,
                            // Only draw lines for the Floor (0) and Ceiling (16)
                            color: (context) => {
                                const val = context.tick.value;
                                if (val === 0 || val === 16) {
                                    return 'rgba(255, 255, 255, 0.1)'; 
                                }
                                return 'transparent';
                            },
                            lineWidth: 1
                        }
                    }
                },
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                }
            }
        });
    }
}